/**
* @Description: Main文件
* @Author: huping
* @Date: 2021-08-16 14:20:25
* @LastEditTime: 2021-08-27 14:03:11
*/

<template>
  <div class="main flex-row" v-loading="loading">
    <global v-if="globalComponentDisplay"></global>
    <aside-menu/>
    <section class="content-wrapper flex-column flex1">
      <nav-tab v-if="navModel === 'tab'"/>
      <nav-bread v-else-if="navModel === 'breadcrumb1'"/>
      <div class="page-content-container flex-column flex1">
        <!-- 匹配到的路由 -->
        <keep-alive :exclude="exclude">
          <router-view></router-view>
        </keep-alive>
        <!-- <no-permission v-else-if="!loading"></no-permission> -->
      </div>
    </section>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import AsideMenu from '@/components/system/AsideMenu';
import navTab from '@/components/system/NavTab';
import navBread from '@/components/system/NavBread';
import global from './common/global-component'
// import noPermission from '@/views/common/no-permission';
// import getUserInfo from '@mocks/get/global/getUserInfo.js'
import loginApi from '@/api/login'
export default {
  name: 'nhMain',
  data() {
    return {
      userId: '',
      isAdmin: '',
      loading: true
    };
  },
  components: {
    AsideMenu,
    navTab,
    navBread,
    global
  },
  methods: {
    countSize(text) {
      let w = 0;
      for (let i=0; i< text.length; i++) {
        let c = text.charCodeAt(i);
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {
          w++;
        } else {
          w+=2;
        }
      }
      return {
        width: w * 12,
        height: w * 6
      }
    },
    waterMarkInit(text = `${this.baseInfo.name}-${new Date().format('yyyy/MM/dd hh:mm:ss')}`) {
      const {width, height} = this.countSize(text)
      const watermark = document.createElement('canvas')
      watermark.width = width
      watermark.height = height
      watermark.style.width = `${width}px`
      watermark.style.height = `${height}px`
      this.oContext = watermark.getContext('2d')
      this.oContext.rotate(-20 * Math.PI / 180)
      this.oContext.font = '14px PingFang SC'
      this.oContext.fillStyle = 'rgba(0, 0, 0, .1)'
      this.oContext.textAlign = 'left'
      this.oContext.textBaseline = 'Middle'
      this.oContext.fillText(text, 10, height * 0.7)

      const id = 'water-mark-musk'
      const dom = document.getElementById(id)
      if (dom) {
        document.body.removeChild(dom)
      }
      const div = document.createElement('div')
      div.id = id
      div.style.pointerEvents = 'none'
      div.style.top = '10px'
      div.style.left = '80px'
      div.style.position = 'fixed'
      div.style.zIndex = '100000'
      div.style.width = '100vw'
      div.style.height = '100vh'
      div.style.background = 'url(' + watermark.toDataURL('image/png') + ') left top repeat'
      document.body.appendChild(div)
    },
    // getUserInfo() {
    //   this.loading = true
    //   this.$mock.get('/userinfo').then(res => {
    //     this.userId = res.id
    //     this.$store.commit('userInfo/baseInfo', res)
    //   }).catch(() => {
    //     const res = getUserInfo.template.data
    //     this.userId = res.id
    //     this.$store.commit('userInfo/baseInfo', res)
    //     // this.$message({
    //     //   message: err.message || '获取用户失败，请重新登录！',
    //     //   type: 'error',
    //     //   showClose: true
    //     // })
    //     // setTimeout(() => {
    //     //   this.$router.replace('/login')
    //     // }, 3000)
    //   }).finally(() => {
    //     this.loading = false
    //     this.waterMarkInit()
    //     setInterval(() => {
    //       this.waterMarkInit()
    //     }, 1000 * 60)
    //   })
    // },
    getUserInfo() {
      this.loading = true
      loginApi.getInfo().then(res => {
        console.log('res', res)
        this.userId = res.userid
        this.isAdmin = res.isAdmin
        this.$store.commit('userInfo/baseInfo', res)
      }).catch((err) => {
        console.log('err', err)
        if (err.code === 6) {
          console.log('process.env', process.env)
          // const host = process.env.VUE_APP_API_BASE_URL
          // const redirect_uri = encodeURI(location.href)
          // const url = `${host}/auth/iam/login?redirect_uri=${redirect_uri}`
          // location.href = url
        } else {
          this.$message({
            message: err.message || '获取用户失败，请重新登录！',
            type: 'error',
            showClose: true
          })
        }
        // setTimeout(() => {
        //   this.$router.replace('/login')
        // }, 3000)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted() {
    this.getUserInfo()
    this.$store.commit('systemMenu/onTabClose', (current, next) => {
      console.log(`关闭${current.title}`)
      next()
    })
  },
  computed: {
    ...mapState('systemMenu', ['tabList', 'activeTab', 'menuList', 'navModel']),
    ...mapState('userInfo', ['baseInfo']),
    ...mapState('global', ['globalComponentDisplay']),
    // 避免关闭tab之后重新打开页面没重新加载
    exclude() {
      const tabNames = this.tabList.map(item => {
        return item.name
      })
      const treeToArry = (list) => {
        const menuArray = []
        function doloop(listTree) {
          for (const item of listTree) {
            if (item.children && item.children.length) {
              doloop(item.children)
            }
            if (item.name) {
              menuArray.push(item)
            }
          }
        }
        doloop(list)
        return menuArray
      }
      // 路由中不缓存的页面,不在tab中的页面均不缓存
      return treeToArry(this.menuList).filter(item => {
        return !item.keepAlive || !tabNames.includes(item.name)
      }).map(item => {
        return item.name
      })
    }
  }
};
</script>

<style scoped lang='scss'>
  .main {
    width: 100vw;
    height: 100vh;
    // overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    .content-wrapper {
      /*transition: all .5s;*/
      padding: 5px;
      padding-top: 54px;
      padding-left: 0;
      box-sizing: border-box;
      background: $color-bg;
      overflow-x: auto;

      .page-content-container {
        background-color: $color-white;
        overflow: auto;
        flex-shrink: 0;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        border-right: 1px solid #e4e4e7;
        border-left: 1px solid #e4e4e7;
        border-bottom: 1px solid #e4e4e7;


      }
    }
  }
</style>
